<template>
  <el-row>
    <el-card :span="24" class="group-search" shadow="never">
      <p class="title-search">Quản lý đơn vị cung cấp dịch vụ</p>
      <el-col :span="24" class="provider-unit-list-btn">
        <div class="paginate-page">
          <p>Số bản ghi trên trang:</p>
          <el-dropdown @command="changePageSize">
          <span class="el-dropdown-link">
            {{ params.limit }}
            <i class="el-icon-caret-bottom"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in listPaginate"
                :key="item.key"
                :command="item.value"
              >{{ item.value }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button type="success" class="btn" @click="$router.push({name: 'ProviderUnitCreate'})" :disabled="hasPermissionOnScreen(PERMISSION_CREATE)">
          <span>Thêm Mới</span>
        </el-button>
        <el-button
          type="danger"
          class="btn"
          v-show="multipleSelection.length !== 0"
          @click="deleteMultiProviderUnits()"
          :disabled="hasPermissionOnScreen(PERMISSION_DELETE)"
        >Xóa</el-button>
        <el-button
          type="danger"
          class="btn"
          v-show="multipleSelection.length === 0"
          @click="deleteMultiProviderUnits()"
          disabled="disabled"
        >Xóa</el-button>
      </el-col>
    </el-card>
    <el-card shadow="never">
      <el-table
        :data="getData"
        style="width: 100%"
        empty-text="Không có dữ liệu"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="code"
          min-width="10"
          label="Mã">
        </el-table-column>
        <el-table-column
        prop="unit"
        min-width="20"
        label="Đơn vị">
        </el-table-column>
        <el-table-column
        min-width="70"
        label="Token ID">
            <template class="action-provider-unit" scope="scope">
              {{ scope.row.token_id }}
              <div v-if="scope.row.token_id"></div>
              <el-button
                type="info"
                icon="el-icon-refresh"
                circle
                size="mini"
                @click="generateNewToken(scope.row.id)"
                :disabled="hasPermissionOnScreen(PERMISSION_UPDATE)">
              </el-button>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" v-if="scope.row.token_id"
                         @click="deleteProviderUnit(scope.row)"
                         :disabled="hasPermissionOnScreen(PERMISSION_DELETE)"></el-button>
            </template>
        </el-table-column>
      </el-table>
      <custom-el-pagination
        :length="total"
        :paginateFrom="paginateFrom"
        :paginateTo="paginateTo"
        :total="total"
        :pageSize="pageSize"
        :page="page"
        @handleCurrentChange="handleCurrentChange"
      ></custom-el-pagination>
    </el-card>
  </el-row>
</template>

<script>
import ProviderUnitRequest from '@/requests/ProviderUnitRequest';
import CONST from '@/config/const';
import { mapState } from 'vuex';

export default {
  name: 'ProviderUnit',
  props: {
    msg: String
  },
  data() {
    return {
      getData: [],
      params: {
        limit: CONST.PAGINATION[0].value
      },
      multipleSelection: [],
      page: 1,
      pageSize: 25,
      total: 0,
      paginateFrom: 1,
      paginateTo: 25,
      listPaginate: CONST.PAGINATION
    }
  },
  computed: {
    ...mapState(['masterdata']),
  },
  methods: {
    async getList(params) {
     const data = await ProviderUnitRequest.getListProviderUnit(params);
     this.getData = data.data.data;
     this.page = data.data.current_page;
     this.pageSize = parseInt(data.data.per_page);
     this.total = data.data.total;
     this.paginateFrom = data.data.from;
     this.paginateTo = data.data.to;
    },
    handleSelectionChange(val) {
      let ids = val.map(function (i) {
        return i.id;
      });
      this.multipleSelection = ids;
    },
    filterStatus(value) {
      return value !== 1 ? false : true;
    },
    handleCurrentChange(val) {
      this.page = val;
      const param = Object.assign(this.params, {
          page: this.page
      });
      this.getList(param);
    },
    async deleteProviderUnit(row) {
      if (await this.showConfirmMixin('Bạn có chắc chắn muốn xóa token không?')) {
        ProviderUnitRequest.deleteProviderUnit(row.id).then(() => {
          const message = this.$t('Xoá thành công.');
          this.showSuccess(message);
          this.getList(this.params);
        }).catch(() => {
          const message = 'Lỗi khi xóa.';
          this.showError(message);
          this.getList(this.params);
        });
      }
    },
    changePageSize(e) {
      this.params.limit = e;
      const params = Object.assign(this.params, {
        page: 1
      });
      this.getList(params);
    },
    async deleteMultiProviderUnits() {
      if (await this.showConfirmMixin()) {
        ProviderUnitRequest.deleteMultiProviderUnits(this.multipleSelection)
          .then(() => {
            this.showSuccess("Xoá thành công.");
            this.getList(this.params);
          })
          .catch(() => {
            this.showError("Lỗi khi xóa.");
            this.getList(this.params);
          });
      }
    },
    async generateNewToken(id) {
      try {
        const response = await ProviderUnitRequest.generateNewToken({id: id});
        if (response.success) {
          this.showSuccess('Cập nhật token thành công.');
        }
      } catch (e) {
      } finally {
        this.getList(this.params);
      }
    }
  },
  created() {
    this.getList(this.params);
  }
}
</script>
<style lang="scss">
  @import "@/assets/sass/_variables";
  .provider-unit-pagination {
    ul.el-pager {
      list-style-type: none;
      padding: 0;
      li {
        display: inline-block;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #606266;
        padding: 0px 15px;
      }
      li.active {
        color: #1989FA;
      }
    }
  }
  .provider-unit-search {
    .el-form {
      padding: 15px;
    }
  }
  .provider-unit-search_button {
    display: flex;
    float: right;
    width: auto;
    .el-form-item__content {
      margin-left: 0px !important;
      float: right;
      width: 100%;
    }
  }
  .provider-unit-search_name .el-form-item__content,
  .provider-unit-search_id .el-form-item__content,
  .provider-unit-search_name_en .el-form-item__content,
  .provider-unit-status .el-form-item__content{
    float: none;
  }

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/sass/_variables";
  .paginate-page {
    position: absolute;
    left: 20px;
    width: 220px;
    display: inline-flex;
    .el-dropdown {
      height: 20px;
      border: revert;
      border: 1px solid var(--select-border);
      color: #4B506D;
      margin-top: 17px;
      width: 45px;
    }
    p {
      font-family: Helvetica;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.3px;
      color: #9FA2B4;
      width: 150px;
    }
  }
  .provider-unit-pagination {
    position: relative;
    .title-paginate {
      position: absolute;
      top: 25px;
      left: 35px;
      font-family: Helvetica;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.3px;
      color: #9FA2B4;
    }
  }
  h3 {
    margin: 40px 0 0;
  }
  a {
    color: #42b983;
  }
  .link-back {
    background: #FFF;
    .link-back-list {
      display: table-cell;
      vertical-align: middle;
      height: 37px;
      a {
        font-family: Helvetica;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #303133;
        padding: 0px 20px;
        height: 37px;
      }
      a.active {
        border-bottom: 2px solid #409EFF;
        padding-bottom: 6px;
      }
    }
  }
  .provider-unit-search {
    margin-top: 20px;
    .title-search {
      font-family: Helvetica;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;
      color: #2C2C2C;
      margin-bottom: 24px;
    }
  }
  .btn-search {
    background: #409EFF;
    border-radius: 4px;
    border-color: #409EFF;
    width: 95px;
    height: 40px;
  }
  .provider-unit-list-btn {
    justify-content: flex-end;
    display: flex;
    margin-bottom: 20px;
  }
  .btn-add {
    background: #67C23A;
    border-radius: 4px;
    border-color: #67C23A;
    font-weight: bold;
  }
  .btn-delete {
    background: #F56C6C;
    border-radius: 4px;
    border-color: #F56C6C;
    font-weight: bold;
  }
  .btn-delete:disabled {
    background: $color_disable_btn;
    border-color: $color_disable_btn;
  }
  .btn-import {
    background: #409EFF;
    border-radius: 4px;
    border-color: #409EFF;
    font-weight: bold;
  }
  .upload-btn-wrapper {
    position: relative;
    display: inline-block;
    input[type=file] {
      width: 95px;
      height: 40px;
      margin-left:12px;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
    .btn-import {
      font-family: Helvetica;
      font-style: normal;
      font-size: 14px;
      line-height: 16px;
      color: #FFF;
      letter-spacing: 0.01em;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 95px;
      height: 40px;
      margin: 0px 12px;
    }
  }
  .btn-export {
    font-weight: bold;
    background: #E6A23C;
    border-radius: 4px;
    border-color: #E6A23C;
  }
  .provider-unit-pagination {
    .el-pagination {
        padding: 20px 0px 10px 0px;
    }
  }
  /deep/.el-form-item__label {
    padding: 0 2px;
  }
</style>
